import { HttpEvent, HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";

const HEADER = "X-Correlation-Id";

function newId(): string {
  const c = globalThis.crypto as { randomUUID?: () => string } | undefined;
  try {
    if (c?.randomUUID) return c.randomUUID();
  } catch {
    // non-secure context — fall through
  }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
}

/**
 * Tags every outbound request with a correlation id (echoed back in the
 * `x-correlation-id` response header). One id spans the client round trip, so
 * all backend log lines for it can be pulled from CloudWatch Logs Insights.
 */
export function correlationInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  if (req.headers.has(HEADER)) return next(req);
  return next(req.clone({ setHeaders: { [HEADER]: newId() } }));
}
